var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG1AnglePir(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7 30.8a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0zm2.5 9.55a2.5 2.5 0 10-3.54 0 2.491 2.491 0 003.54 0zm.8-14.69a2.57 2.57 0 10-2.57-2.57A2.58 2.58 0 0039 25.66zm-7.71.72a2.5 2.5 0 10-.01 0h.01zm.46 7.51a2.5 2.5 0 10-3.54 0 2.5 2.5 0 003.53 0h.01zm-3 8.43a2.5 2.5 0 10-.03 0h.03zm-3.46-14.9a2.5 2.5 0 10-3.53 0 2.5 2.5 0 003.5 0h.03zm-3 3.44a2.5 2.5 0 10.943.184 2.502 2.502 0 00-.963-.184h.02zM21 38.51a2.57 2.57 0 10.02 5.14 2.57 2.57 0 00-.02-5.14zM70 6v64H6V6h64zm-4 4H13.43l6.34 6.35a3.2 3.2 0 01.93 2.38A3 3 0 0115.62 21L10 15.35V66h56V10z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/G1_Angle_PIR.4cbe15af.svg";
export { SvgG1AnglePir as ReactComponent };